<div aria-labelledby="contact-tab" class="tab-pane tab-content fade" id="day5" role="tabpanel">
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="content-block">
            <div class="error-list" v-if="ui.error.error_message">
                <ul class="error-msg">
                    <li :key="x" v-for="(error,x) in ui.error.error_message">
                        <div :key="i" v-for="(err,i) in error">
                            <p> {{err}}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <form>
                <div class="form-modified">
                    <div class="empty-data green">
                        <p>
                            You can add, edit, move, or delete the destination.
                        </p>
                    </div>
                    <div v-if="!ui.status.canAdd && permission.trekDestination_add">
                        <a @click.prevent="showAddDestinationButton()" class="btn default-btn" href=""><i
                                class="fas fa-plus"></i> Add Destination</a>
                    </div>
                    <div class="form-group row" v-if="ui.status.canAdd">
                        <!-- <label for="inputPassword" class="col-sm-2 col-form-label"
                                  >Destinations covered</label> -->
                        <div class="col-sm-8 offset-lg-2">
                            <div class="multiselect-input">
                                <multiselect :class="{ 'error-input' : ui.error.errors['destination_id'] }"
                                             :options='item.masterDestinationData'
                                             :track-by="'name'"
                                             label="name" placeholder="Choose Destination"
                                             v-model="item.addDestination"></multiselect>
                                <validation-error :errors="ui.error.errors" :field="'destination_id'"
                                                  :isError="ui.error.has_error"
                                                  v-if="ui.error.has_error"/>
                            </div>
                        </div>
                        <div class="col-sm-2" v-if="permission.trekDestination_add">
                            <a @click.prevent="createDestination" class="btn btn-sm add-btn" href="#" role="button">
                                {{buttonName}}
                                <spinner :loading="ui.status.postLoading.createDestination" v-if="ui.status.postLoading.createDestination"></spinner>
                            </a>
                        </div>

                    </div>
                    <hr>
                    <div class="form-group row" v-if="item.destinationList.length > 0 && permission.trekDestination_list">
                        <label class="col-sm-2 col-form-label" for="inputPassword">Destinations
                            covered</label>
                        <div class="col-sm-10" v-if="item.destinationList">
                            <div :key="index"
                                 class="form-group row align-items-center"
                                 v-for="(destination, index) in item.destinationList">
                                <div class="col-sm-8">
                                    <label class="readonly hoverable-list" v-if="!destination.IsActive">
                                        <div class="up-down">
                                            <button @click.prevent="moveDestinationUp(index, destination)"
                                                    class="btn arrange-btn"
                                                    v-if="index != 0"><i
                                                    class="fas fa-level-up-alt"></i></button>
                                            <button @click.prevent="moveDestinationDown(index, destination)"
                                                    class="btn arrange-btn"
                                                    v-if="index !== item.destinationList.length -1"><i
                                                    class="fas fa-level-down-alt"></i></button>
                                        </div>

                                        <span
                                                v-if="destination.destination">{{destination.destination ? destination.destination.name : ''}}</span>
                                    </label>

                                    <div class="multiselect-input" v-if="destination.IsActive">
                                        <multiselect :class="{ 'error-input' : ui.error.errors['edit_destination_id'] }"
                                                     :options='item.masterDestinationData' :track-by="'name'"
                                                     label="name"
                                                     placeholder="Choose Destination.."
                                                     v-model="item.editDestination.destination"></multiselect>
                                        <validation-error :errors="ui.error.errors" :field="'edit_destination_id'"
                                                          :isError="ui.error.has_error"
                                                          v-if="ui.error.has_error"/>
                                    </div>

                                </div>
                                <div class="col-lg-4">
                                    <div class="includes-action justify-content-start">
                                        <button @click.prevent="onEditDestinationClick(index, destination)"
                                                class="btn blue"
                                                type="button"
                                                v-if="!ui.status.canEdit && permission.trekDestination_edit">
                                            <i class="fas fa-pen"></i>
                                        </button>
                                        <button @click.prevent="updateDestination"
                                                class="btn green" type="button"
                                                v-if="destination.IsActive === true && permission.trekDestination_edit">
                                            <i class="fas fa-save"></i>
                                        </button>
                                        <button @click.prevent="onCancelDestinationClick(index,destination)"
                                                class="btn red" type="button"
                                                v-if="destination.IsActive">
                                            <i class="fas fa-times"></i>
                                        </button>
                                        <button @click.prevent="onDeleteDestinationClick(index, destination)"
                                                class="btn red"
                                                type="button"
                                                v-if="!destination.IsActive && permission.trekDestination_delete">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="modal-wrap">
                                    <div aria-labelledby="exampleModalLabel" class="modal fade show" id="delete"
                                         role="dialog"
                                         tabindex="-1">
                                        <div class="modal-dialog modal-dialog-centered" role="document">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h5 class="modal-title">Delete Destinations Covered</h5>
                                                    <button aria-label="Close" class="close" data-dismiss="modal"
                                                            type="button">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>
                                                <div class="error-list" v-if="ui.error.modal.delete">
                                                    <ul class="error-msg">
                                                        <li :key="x" v-for="(error,x) in ui.error.modal.delete">
                                                            <div :key="i" v-for="(err,i) in error">
                                                                <p> {{err}}</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="modal-body">
                                                    <p>Are you sure you want to delete this ?</p>
                                                </div>

                                                <div class="modal-footer">
                                                    <button @click.prevent="deleteDestinationAction()"
                                                            class="btn default-btn"
                                                            type="button">Ok
                                                        <spinner :loading="ui.status.postLoading.deleteDestination" v-if="ui.status.postLoading.deleteDestination"></spinner>
                                                    </button>
                                                    <button @click.prevent="hideDeleteDestinationModal()"
                                                            aria-label="Close"
                                                            class="btn default-btn cancel"
                                                            type="button" :disabled="ui.status.postLoading.deleteDestination">Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="empty-data">
                        <p v-if="item.destinationList.length == 0 ">No Destination List</p>
                    </div>
                </div>
            </form>
        </div>
    </div>

</div>
